module.exports = __webpack_public_path__ + "img/weal_5.65d87838.jpg";